import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import CreateClassWithManyTeachersForm from "../Forms/CreateClassWithManyTeachersForm";
class CreateClassWithManyTeachersModal extends React.Component {
  render() {
    return (
      <Modal
        style={{ maxWidth: "700px", width: "80%" }}
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
      >
        <ModalHeader>Skapa klass</ModalHeader>
        <ModalBody>
          <CreateClassWithManyTeachersForm
            teachers={this.props.teachers}
            school={this.props.school}
            updateStudents={this.props.updateStudents}
            dismissModal={this.props.dismissModal}
            reloadClasses={this.props.reloadClasses}
            programmes={this.props.programmes}
            orientations={this.props.orientations}
            preselectedProgramme={this.props.preselectedProgramme}
            fullAccess={this.props.fullAccess}
            preselectedTeacher={this.props.preselectedTeacher}
          />
        </ModalBody>
      </Modal>
    );
  }
}

export default CreateClassWithManyTeachersModal;
